module.exports = __webpack_public_path__ + "img/logo.71ec3f45.png";